//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
let d=[[],[[[],"GetFolderName",{R_:{folderName:''}},0,0],[["folderName"],"SetFolderName",{},1,0],[[],"GetCurrentFolder",{R_:{folder:"Annotations.PartSymbolFolder"}},0,0],[[],"GetParent",{R_:{parentfolder:"Annotations.PartSymbolFolder"}},0,0],[["parentfolder"],"SetParent",{},1,0],[[],"GetRootFolder",{R_:{rootFolder:"Annotations.PartSymbolFolder"}},0,0],[[],"IsRootFolder",{R_:{isRootFolder:''}},0,0],[["numChildren"],"GetChildren",{R_:{children:"Annotations.PartSymbolFolder[]"}},0,0],[[],"GetFolderCount",{R_:{count:''}},0,0],[[],"GetPartSymbolCount",{R_:{count:''}},0,0],[["numMasterSymbols"],"GetPartSymbols",{R_:{masterSymbols:"Annotations.MasterSymbol[]"}},0,0]],[]];
SPLM.Annotations.PartSymbolFolderBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PartSymbolFolderBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;